import { canv } from "@/canv/global.js";
import { Shape } from "../shape";

export class ShapeOr extends Shape {
    includeText = false;

    draw(x: number, y: number, width: number, height: number) {
        canv.ctx.beginPath();
        canv.ctx.ellipse(
            x + width / 2,
            y + height / 2,
            height / 2,
            width / 2,
            Math.PI / 2,
            0,
            2 * Math.PI,
        );

        canv.ctx.moveTo(x + width / 2, y);
        canv.ctx.lineTo(x + width / 2, y + height);

        canv.ctx.moveTo(x, y + height / 2);
        canv.ctx.lineTo(x + width, y + height / 2);
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" d="M0 0h24v24H0z"/>
                <path stroke="${stroke}" d="M12.1651 1v22M1 12.11h22m-.4399-.11c0 5.8321-4.7279 10.56-10.56 10.56-5.8322 0-10.56-4.7279-10.56-10.56C1.44 6.1678 6.1679 1.44 12 1.44c5.8321 0 10.56 4.7279 10.56 10.56Z"/>
            </svg>
        `;
    }
}
